/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseFunctionCallArgumentsDoneEvent = {
  type: "response.function_call_arguments.done";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  name: string;
  arguments: string;
};

/** @internal */
export const ResponseFunctionCallArgumentsDoneEvent$inboundSchema: z.ZodType<
  ResponseFunctionCallArgumentsDoneEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.function_call_arguments.done"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  name: z.string(),
  arguments: z.string(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseFunctionCallArgumentsDoneEvent$Outbound = {
  type: "response.function_call_arguments.done";
  sequence_number: number;
  item_id: string;
  output_index: number;
  name: string;
  arguments: string;
};

/** @internal */
export const ResponseFunctionCallArgumentsDoneEvent$outboundSchema: z.ZodType<
  ResponseFunctionCallArgumentsDoneEvent$Outbound,
  z.ZodTypeDef,
  ResponseFunctionCallArgumentsDoneEvent
> = z.object({
  type: z.literal("response.function_call_arguments.done"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  name: z.string(),
  arguments: z.string(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseFunctionCallArgumentsDoneEventToJSON(
  responseFunctionCallArgumentsDoneEvent:
    ResponseFunctionCallArgumentsDoneEvent,
): string {
  return JSON.stringify(
    ResponseFunctionCallArgumentsDoneEvent$outboundSchema.parse(
      responseFunctionCallArgumentsDoneEvent,
    ),
  );
}
export function responseFunctionCallArgumentsDoneEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseFunctionCallArgumentsDoneEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseFunctionCallArgumentsDoneEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseFunctionCallArgumentsDoneEvent' from JSON`,
  );
}
